import { interpolationFormat } from "@/partner/shared/lib";

/** Длительность в часах, минутах и секундах для ключей duration.*. */
export function splitDuration(totalSeconds: number): {
  hours: number;
  minutes: number;
  seconds: number;
} {
  const safe = Math.max(0, Math.round(totalSeconds));
  return {
    hours: Math.floor(safe / 3600),
    minutes: Math.floor((safe % 3600) / 60),
    seconds: safe % 60,
  };
}

type Translate = (key: string, options?: Record<string, unknown>) => string;

/** «1 ч 52 мин», «12 мин», «40 с». */
export function formatDuration(t: Translate, totalSeconds: number): string {
  const { hours, minutes, seconds } = splitDuration(totalSeconds);
  if (hours > 0) {
    return t("streams.monitoring.duration.hoursMinutes", { hours, minutes });
  }
  if (minutes > 0) {
    return t("streams.monitoring.duration.minutes", { minutes });
  }
  return t("streams.monitoring.duration.seconds", { seconds });
}

/**
 * Момент для сводки и журнала: только время, если это сегодня, иначе дата
 * и время (у периода «24 часа» и длинных эфиров обрывы бывают вчера).
 */
export function formatMoment(
  at: string | Date,
  lng: string,
  now: Date = new Date()
): string {
  const date = new Date(at);
  const sameDay = date.toDateString() === now.toDateString();
  return interpolationFormat(date, sameDay ? "time" : "dateTime", lng);
}
